import { gql } from "@apollo/client";

export const PUSH_TOKEN_NOTIF = gql`
mutation pushTokenNotif($token: String!, $bookingId: String, $lang: String!) {
  pushTokenNotif(token: $token, bookingId: $bookingId, lang: $lang) {
    result
  }
}
`;

export const COMFIRM_EVENT = gql`
mutation confirmEvent($eventId: String!) {
  comfirmEvent(eventId: $eventId) {
    result
  }
}
`

export const EDIT_FINISHED_EVENT = gql`
mutation editFinishedEvent($eventId: String!, $editObject: finishedEventEditObject!) {
  editFinishedEvent(eventId: $eventId, editObject: $editObject) {
    result
  }
}
`

export const CREATE_BOOKING_REQUEST = gql`
mutation createBookingRequest($appartId: String!, $departureDate: String!, $arrivalDate: String!, $reason: String!){
  createBookingRequest(appartId: $appartId, departureDate: $departureDate, arrivalDate: $arrivalDate, reason: $reason){
    result
  }
}
`

export const ADD_PROBLEM = gql`
mutation addProblem($eventId: String!, $title: String!, $description: String!, $images: [String!]!){
  addProblem(eventId: $eventId, title: $title, description: $description, images: $images) {
    result
  }
}
`

export const ADD_CONSUMABLE = gql`
mutation addConsumablePresta($totalPriceTTC: Float!, $purchaseDate: DateTime! $images: [String!]!, $appartId: String!){
  addConsumablePresta(totalPriceTTC: $totalPriceTTC, purchaseDate: $purchaseDate, images: $images, appartId: $appartId) {
    result
  }
}
`

export const MODIFY_PROBLEM = gql`
mutation UpdateProblem($eventId: String!, $title: String!, $description: String!, $index: Float!){
  UpdateProblem(eventId: $eventId, title: $title, description: $description, index: $index) {
    result
  }
}
`

export const FINISH_PROBLEM = gql`
mutation finishEvent($eventId: String!, $todoList: [TodoListType!]!, $commentary: String!, $images: [String!]!) {
  finishEvent(eventId: $eventId, todoList: $todoList, commentary: $commentary, images: $images) {
    result
  }
}
`

export const REMOVE_ACHAT_DECLARATION = gql`
mutation removeAchatDeclaration($achatId: String!) {
  removeAchatDeclaration(achatId: $achatId) {
    result
  }
}
`